import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import React from 'react';

export const LabelISSPanelButton = React.memo((props: TopNavBarButtonProps) => (
	<TopNavBarButtonComponent {...props}>
		{props.btnDef?.label || ' '}
	</TopNavBarButtonComponent>
));